import * as React from "react";
import Dropzone from "react-dropzone";
import styled from "styled-components";

let CoreDropzone = null;

if (Dropzone) {
  CoreDropzone = styled(Dropzone)`
    border: 2px dashed #666;
    border-radius: 5px;
    box-sizing: border-box;
    position: relative;
    padding: 30px;
    cursor: pointer;
  `;
}

export default CoreDropzone;



// WEBPACK FOOTER //
// ./app/javascript/components/core/CoreDropzone.tsx